export const SeverityLevelID = {
    LOW: 2,
    NOT_APPLICABLE: 4,
};

export const AuditStatusID = {
    IN_PROGRESS: 1,
    IN_REVIEW: 2,
    COMPLETED: 3,
    EDITS_REQUIRED: 4,
};

export const AuditStatusNames = {
    [AuditStatusID.IN_PROGRESS]: {"id": AuditStatusID.IN_PROGRESS, "name": "In Progress"},
    [AuditStatusID.IN_REVIEW]: {"id": AuditStatusID.IN_REVIEW, "name": "In Review"},
    [AuditStatusID.EDITS_REQUIRED]: {"id": AuditStatusID.EDITS_REQUIRED, "name": "Edits Required"},
};

export const INSPECTION_EDIT_STATUSES = [AuditStatusID.IN_PROGRESS,
    AuditStatusID.IN_REVIEW,
    AuditStatusID.EDITS_REQUIRED];

export const AuditItemType = {
    PIN: "pin",
    LINE: "line",
    AREA: "area",
};

export const AuditItemTypeID = {
    PIN: 1,
    LINE: 2,
    AREA: 3,
};

export const AnnotationType = {
    ISSUE: "issue",
    LINE: AuditItemType.LINE,
    AREA: AuditItemType.AREA,
};

export const AnnotationType2 = {
    "issue": AuditItemType.PIN,
    "line": AuditItemType.LINE,
    "area": AuditItemType.AREA,
};

export const AuditItemTypeTitle = {
    PINS: "Pins",
    LINES: "Lines",
    AREAS: "Areas",
};

export const AuditItemTypeInitialFilters = {
    "pins": [],
    "lines": [],
    "areas": [],
    "severity": [],
    "phases": [],
    "default": true,
};

export const AnnotationShapeIDMap = {
    PIN: {id: AuditItemTypeID.PIN, query: AuditItemType.PIN},
    LINE: {id: AuditItemTypeID.LINE, query: AuditItemType.LINE},
    AREA: {id: AuditItemTypeID.AREA, query: AuditItemType.AREA},
};

export const InspectionCategoryTypeID = {
    ASSESSMENT: 1,
};
